<template>
  <div class="users f-c-b f-d-c w-100 o-f-a h-100 p-4 pb-22">
    <div class="addNewUser addNewSession meetDetails f-s-s f-d-c w-100 p-4">
      <div class="title f-c-b w-100 pt-1 mb-4">
        <div class="f-c-s">
          <b-img class="title-icon ml-2" :src="require(`@/assets/images/gap/details-meeting.svg`)"></b-img>
          <div class="title-text f-c-c">
            جزئیات جلسه
            <span class="meetStatus f-c-c mr-1">{{ "( " + sessionInfo.status + " )" }}</span>
          </div>
        </div>
        <div class="return f-c-s returnBtn" @click="returnFunc()">
          <div class="returnText f-c-c m-0">برگشت</div>
          <!-- <div class="arrow f-c-c mr-1">&gt;</div> -->
        </div>
      </div>
      <div
        class="addUserBox addUserBoxStep3 addUserBoxStep3Mobile f-c-s f-d-c w-100 mb-2"
        style="border-top: 1px solid #125488; border-radius: 10px"
      >
        <div class="row f-c-s w-100 mb-3">
          <div class="label f-c-s">عنوان</div>
          <input v-model="title" type="text" />
        </div>
        <div class="row f-c-s w-100 mb-3">
          <div class="label f-c-s">ظرفیت</div>
          <input v-model="capacity" type="number" placeholder="100 نفر" />
        </div>
        <div class="row f-c-s w-100 mb-4">
          <div class="label f-c-s">گروه جلسه</div>
          <div class="left f-c-b">
            <select class="sessionGroup" v-model="sessionGroup">
              <option v-for="(v, i) in allSessionGroups.session_groups" :key="i" :value="v.id">
                {{ v.title ? v.title : "" }}
              </option>
            </select>
          </div>
        </div>
        <div v-if="user.is_organ == 'yes'" class="row f-c-s w-100 mb-4">
          <div class="label f-c-s">سازمان</div>
          <div class="left f-c-b">
            <select class="sessionGroup" v-model="userOrg">
              <option v-for="(v, i) in allUserOrg.organ_list" :key="i" :value="v.id">
                {{ v.title ? v.title : "" }}
              </option>
            </select>
          </div>
        </div>
        <div class="row f-c-s w-100 mb-4">
          <div class="label f-c-s">وضعیت</div>
          <div class="left f-c-b">
            <select class="sessionGroup" v-model="statusVal">
              <option v-for="(v, i) in statusList" :key="i" :value="v.id">
                {{ v.title ? v.title : "" }}
              </option>
            </select>
          </div>
        </div>
        <div class="row detailGuest guestMobile w-100 f-c-b">
          <div class="checkboxSec f-c-s">
            <label for="d1" class="ml-1">امکان ورود به صورت مهمان</label>
            <select class="sessionGroup" v-model="guestStatus">
              <option v-for="(v, i) in guestList" :key="i" :value="v">
                {{ v.title }}
              </option>
            </select>
          </div>
          <div v-if="user.permissions.edit_general" class="record f-c-c" @click="recordMeetBtn()">ویرایش</div>
        </div>
      </div>
      <div class="tabSection f-c-s w-100">
        <div
          class="tabIcon w-22 f-c-c"
          @click="setClickTabNavFunc(0)"
          :class="[isActiveTab == 0 ? 'active' : '']"
        >
          کاربران
        </div>
        <div
          class="tabIcon w-22 f-c-c"
          @click="setClickTabNavFunc(1)"
          :class="[isActiveTab == 1 ? 'active' : '']"
        >
          سانس ها
        </div>
        <div
          class="tabIcon w-22 f-c-c"
          @click="setClickTabNavFunc(2)"
          :class="[isActiveTab == 2 ? 'active' : '']"
        >
          اطلاع رسانی
        </div>
        <div
          class="tabIcon w-34 f-c-c"
          @click="setClickTabNavFunc(3)"
          :class="[isActiveTab == 3 ? 'active' : '']"
        >
          تکنولوژی و قالب اختصاصی
        </div>
        <div
          class="tabIcon w-34 f-c-c"
          @click="setClickTabNavFunc(4)"
          :class="[isActiveTab == 4 ? 'active' : '']"
        >
          پشتیبانی ویژه
        </div>
      </div>
      <div class="tabTable f-c-c w-100">
        <div
          v-if="isActiveTab == 0"
          class="addUserBox addUserBoxStep2 addUserBoxStep2Mobile f-c-s f-d-c w-100"
          style="padding: 10px 5px"
        >
          <div class="f-c-e search-addUser w-100 mb-3">
            <div class="search f-c-c">
              <input
                v-if="isSearchUserActive"
                :class="[isSearchUserActive ? 'searchUserInputActive' : '']"
                v-model="searchUser"
                type="text"
                placeholder="جستجو"
              />
              <b-img
                :class="[isSearchUserActive ? 'imgActive' : '']"
                :src="require(`@/assets/images/gap/search-icon.svg`)"
                @click="searchUserIconFunc()"
              ></b-img>
            </div>
            <div
              v-if="user.permissions.edit_session_add_user"
              @click.prevent="addNewUserFunc()"
              class="addUser f-c-c"
            >
              <span class="plus ml-2">+</span>
              <div class="text f-c-c">افزودن کاربر</div>
            </div>
          </div>

          <div class="userTable sessionAddUser f-c-s f-d-c w-100 mb-3">
            <div class="header f-c-s w-100">
              <div class="headerItem f-c-s"></div>
              <div class="headerItem f-c-s w-25">نام</div>
              <div class="headerItem f-c-s">موبایل</div>
              <!-- <div class="headerItem f-c-s">ایمیل</div> -->
              <div class="headerItem f-c-s w-20">نقش</div>
              <div class="headerItem f-c-c w-30">عملیات</div>
            </div>
            <div v-if="itemsForList.length" class="tableContent f-c-s f-d-c w-100">
              <div v-for="(v, i) in itemsForList" :key="i" class="tableRow f-c-s w-100">
                <div class="tableItem f-c-c">{{ v ? v.row : "" }}</div>
                <div class="tableItem f-c-s w-25">
                  <div
                    class="f-c-s w-90"
                    :title="v.first_name + ' ' + v.last_name"
                    style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
                  >
                    {{ v ? v.first_name + " " + v.last_name : "" }}
                  </div>
                </div>
                <div class="tableItem f-c-s">{{ v ? v.mobile : "" }}</div>
                <!-- <div class="tableItem f-c-s">
                  <div
                    class="f-c-s w-90"
                    :title="v.email"
                    style="
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ v.email ? v.email : "-" }}
                  </div>
                </div> -->
                <div class="tableItem f-c-s w-20">
                  {{
                    v
                      ? allRole && allRole.information
                        ? allRole.information.filter((word) => word.id == v.role)[0]
                          ? allRole.information.filter((word) => word.id == v.role)[0].title
                          : ""
                        : ""
                      : ""
                  }}
                </div>
                <div class="tableItem f-c-sa w-30">
                  <div
                    v-if="user.permissions.edit_session_edit_user"
                    class="editBtn f-c-c"
                    @click.prevent="editUserFunc(v)"
                  >
                    ویرایش
                  </div>
                  <div
                    v-if="user.permissions.edit_session_deleteUser"
                    class="deleteBtn f-c-c"
                    @click.prevent="deleteUserFunc(v)"
                  >
                    حذف
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="tableContent emptyTable f-c-c w-100 h-100">کاربری وجود ندارد.</div>
            <div class="paginationSection f-c-c w-100">
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
              ></b-pagination>
            </div>
          </div>
          <div v-if="users.length" class="mobileUserTable f-c-s f-d-c w-100 mb-3">
            <div v-for="(v, i) in users" :key="i" class="tableItem f-c-s f-d-c w-100 mb-3">
              <div class="up f-c-b w-100 mb-3">
                <div class="right f-s-s f-d-c">
                  <div class="labelItem f-c-c mb-2">نام :</div>
                  <div class="labelItem f-c-c mb-2">موبایل :</div>
                  <!-- <div class="labelItem f-c-c mb-2">ایمیل :</div> -->
                  <div class="labelItem f-c-c">نقش :</div>
                </div>
                <div class="left f-e-e f-d-c">
                  <div class="answerItem f-c-e mb-2">
                    {{ v ? v.first_name + " " + v.last_name : "-" }}
                  </div>
                  <div class="answerItem f-c-e mb-2">
                    {{ v.mobile }}
                  </div>
                  <!-- <div class="answerItem f-c-e mb-2">
                    {{ v.email }}
                  </div> -->
                  <div class="answerItem f-c-e">
                    {{
                      allRole.information
                        ? allRole.information.filter((word) => word.id == v.role)[0].title
                        : ""
                    }}
                  </div>
                </div>
              </div>
              <div class="down f-c-b w-100">
                <div
                  v-if="user.permissions.edit_session_edit_user"
                  class="edit f-c-c"
                  @click.prevent="editUserFunc(v)"
                >
                  <b-img :src="require(`@/assets/images/mobile/edit-pen.svg`)"></b-img>
                </div>
                <div
                  v-if="user.permissions.edit_session_deleteUser"
                  class="delete f-c-c"
                  @click.prevent="deleteUserFunc(v)"
                >
                  <b-img :src="require(`@/assets/images/mobile/delete-x.svg`)"></b-img>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="mobileUserTable tableContent emptyTable f-c-c w-100 h-100 mb-3">
            کاربری وجود ندارد.
          </div>
        </div>
        <div
          v-if="isActiveTab == 1"
          class="addUserBox addUserBoxStep2 addUserBoxStep2Mobile f-c-s f-d-c w-100 mb-2"
          style="padding: 10px 5px"
        >
          <div class="search-addUser pr-2 f-c-b w-100">
            <div class="f-c-e search-addUser w-100 mb-3">
              <div class="search f-c-c">
                <input
                  v-if="isSearchSansActive"
                  :class="[isSearchSansActive ? 'searchUserInputActive' : '']"
                  v-model="searchSans"
                  type="text"
                  placeholder="جستجو"
                />
                <b-img
                  :class="[isSearchSansActive ? 'imgActive' : '']"
                  :src="require(`@/assets/images/gap/search-icon.svg`)"
                  @click="searchSansIconFunc()"
                ></b-img>
              </div>
              <div
                v-if="user.permissions.edit_session_add_sans"
                @click.prevent="addNewSansFunc()"
                class="addUser f-c-c"
              >
                <span class="plus ml-2">+</span>
                <div class="text f-c-c">مورد جدید</div>
              </div>
            </div>
          </div>
          <div class="userTable meetTable f-c-c f-d-c w-100">
            <div class="header f-c-s w-100">
              <div class="headerItem f-c-s"></div>
              <div class="headerItem f-c-s w-20">عنوان</div>
              <div class="headerItem f-c-s">تاریخ</div>
              <div class="headerItem f-c-s">ساعت</div>
              <div class="headerItem f-c-s w-12">توضیحات</div>
              <div class="headerItem f-c-c w-33">عملیات</div>
            </div>
            <div v-if="itemsForList2.length" class="tableContent f-c-c f-d-c w-100">
              <div
                v-for="(v, i) in itemsForList2"
                :key="i"
                class="tableRow f-c-s w-100"
                :class="[v.flag == 'green' ? 'activeGreen' : v.flag == 'red' ? 'activeRed' : 'activeYellow']"
              >
                <div class="tableItem f-c-c">{{ v ? v.row : "" }}</div>
                <div class="tableItem f-c-s w-20">{{ v ? v.title : "-" }}</div>
                <div class="tableItem f-c-s">
                  {{ v ? v.date_from_label : "" }}
                </div>
                <div class="tableItem f-c-s">
                  {{
                    v
                      ? v.time_from.split(":")[0] +
                        ":" +
                        v.time_from.split(":")[1] +
                        " " +
                        "تا" +
                        " " +
                        v.time_to.split(":")[0] +
                        ":" +
                        v.time_to.split(":")[1]
                      : ""
                  }}
                </div>
                <div class="tableItem f-c-s w-12">
                  {{ v ? v.status : "" }}
                </div>
                <div class="tableItem f-c-sa w-33">
                  <v-select
                    @input="setSelectedSans"
                    @close="closeAction(v)"
                    placeholder="عملیات"
                    :options="actionList"
                    :reduce="(option) => option.id"
                    label="title"
                    class="selectActions"
                  />
                  <div
                    v-if="user.permissions.edit_session_show_records_sans && v.recordings == 'yes'"
                    class="recordIcon f-c-c"
                    @click.prevent="showRecordFunc(v)"
                  >
                    ضبط شده ها
                  </div>
                  <div v-else style="visibility: hidden">ضبط شده ها</div>
                  <!-- <b-img
                    v-if="user.permissions.edit_session_show_records_sans"
                    title="ضبط شده ها"
                    @click.prevent="showRecordFunc(v)"
                    class="ml-2"
                    :src="require(`@/assets/images/gap/record-icon.svg`)"
                  ></b-img> -->
                  <!-- <b-img
                  v-if="user.permissions.edit_session_edit_sans"
                  @click.prevent="editSansFunc(v)"
                  class="ml-2"
                  :src="require(`@/assets/images/gap/edit-icon.svg`)"
                ></b-img>
                <b-img
                  v-if="user.permissions.edit_session_delete_sans"
                  @click.prevent="deleteSansFunc(v)"
                  class="ml-2"
                  :src="require(`@/assets/images/gap/delete-icon.svg`)"
                ></b-img> -->
                  <a
                    v-if="v.flag == 'white' && v.url && user.permissions.edit_session_enter_sans"
                    @click="goToSessionFunc('https://vadaroom.ec.iau.ir/v/' + v.url)"
                    class="enterSission f-c-c"
                    >ورود</a
                  >
                  <div v-else class="enterSission disabledBtn f-c-c">ورود</div>
                </div>
              </div>
            </div>
            <div v-else class="tableContent emptyTable f-c-c w-100 h-100">سانسی وجود ندارد.</div>
            <div class="paginationSection f-c-c w-100">
              <b-pagination
                v-model="currentPage2"
                :total-rows="rows2"
                :per-page="perPage2"
                aria-controls="my-table"
              ></b-pagination>
            </div>
          </div>
          <div v-if="sanses.length" class="mobileUserTable f-c-s f-d-c w-100 mb-3">
            <div
              v-for="(v, i) in sanses"
              :key="i"
              class="tableItem f-c-s f-d-c w-100 mb-3"
              :class="[v.flag == 'green' ? 'activeGreen' : v.flag == 'red' ? 'activeRed' : 'activeYellow']"
            >
              <div class="up f-c-b w-100 mb-3">
                <div class="right f-s-s f-d-c">
                  <div class="labelItem f-c-c mb-2">عنوان :</div>
                  <div class="labelItem f-c-c mb-2">تاریخ :</div>
                  <div class="labelItem f-c-c mb-2">ساعت :</div>
                  <div class="labelItem f-c-c mb-2">توضیحات :</div>
                </div>
                <div class="left f-e-e f-d-c">
                  <div class="answerItem f-c-e mb-2">
                    {{ v.title }}
                  </div>
                  <div class="answerItem f-c-e mb-2">
                    {{ v.date_from_label }}
                  </div>
                  <div class="answerItem f-c-e mb-2">
                    {{
                      v
                        ? v.time_from.split(":")[0] +
                          ":" +
                          v.time_from.split(":")[1] +
                          " " +
                          "تا" +
                          " " +
                          v.time_to.split(":")[0] +
                          ":" +
                          v.time_to.split(":")[1]
                        : ""
                    }}
                  </div>
                  <div class="answerItem f-c-e mb-2">
                    {{ v ? v.status : "" }}
                  </div>
                </div>
              </div>
              <div class="down f-c-b w-100">
                <div
                  v-if="user.permissions.edit_session_show_records_sans && v.recordings == 'yes'"
                  class="edit f-c-c w-20"
                  @click.prevent="showRecordFunc(v)"
                >
                  <b-img
                    style="width: 28px"
                    :src="require(`@/assets/images/mobile/record-icon-white.png`)"
                  ></b-img>
                </div>
                <div
                  v-if="user.permissions.edit_session_edit_sans"
                  class="edit f-c-c w-20"
                  @click.prevent="editSansFunc(v)"
                >
                  <b-img :src="require(`@/assets/images/mobile/edit-pen.svg`)"></b-img>
                </div>
                <div
                  v-if="user.permissions.edit_session_delete_sans"
                  class="delete f-c-c w-20"
                  @click.prevent="deleteSansFunc(v)"
                >
                  <b-img :src="require(`@/assets/images/mobile/delete-x.svg`)"></b-img>
                </div>
                <a
                  v-if="v.flag == 'white' && v.url && user.permissions.edit_session_enter_sans"
                  @click="goToSessionFunc('https://vadaroom.ec.iau.ir/v/' + v.url)"
                  class="enterSission f-c-c w-20"
                  >ورود</a
                >
                <div v-else class="enterSission disabledBtn f-c-c">ورود</div>
              </div>
            </div>
          </div>
          <div v-else class="mobileUserTable tableContent emptyTable f-c-c w-100 h-100 mb-3">
            سانسی وجود ندارد.
          </div>
        </div>
        <div
          v-if="isActiveTab == 2"
          class="addUserBox addUserBoxStep2 addUserBoxStep2Mobile f-c-s f-d-c w-100 mb-2"
          style="padding: 10px 5px"
        >
          <div class="search-addUser pr-2 f-c-e w-100 mb-3">
            <div
              v-if="user.permissions.edit_session_add_notification"
              @click.prevent="noticesFunc()"
              class="addUser f-c-c"
            >
              <span class="plus ml-2">+</span>
              <div class="text f-c-c">مورد جدید</div>
            </div>
          </div>
          <div class="userTable meetTable noticeTable f-c-c f-d-c w-100">
            <div class="header f-c-s w-100">
              <div class="headerItem f-c-s"></div>
              <div class="headerItem f-c-s">نوع</div>
              <div class="headerItem f-c-s">تاریخ ارسال</div>
              <div class="headerItem f-c-s">ساعت ارسال</div>
              <div class="headerItem f-c-s">تعداد</div>
              <div class="headerItem f-c-c">وضعیت</div>
              <div class="headerItem f-c-c">عملیات</div>
            </div>
            <div v-if="itemsForList3.length" class="tableContent f-c-c f-d-c w-100">
              <div v-for="(v, i) in itemsForList3" :key="i" class="tableRow f-c-s w-100 mb-2">
                <div class="tableItem f-c-c">{{ v ? v.row : "" }}</div>
                <div class="tableItem f-c-s">{{ v ? v.send_type : "" }}</div>
                <div class="tableItem f-c-s">
                  {{ v ? v.send_date : "" }}
                </div>
                <div class="tableItem f-c-s">
                  {{ v ? v.send_time : "" }}
                </div>
                <div class="tableItem f-c-s">
                  {{ v ? v.count : "" }}
                </div>
                <div class="tableItem f-c-c">
                  {{ v ? v.status : "" }}
                </div>
                <div class="tableItem f-c-c">
                  <div
                    v-if="v.delete_flag && user.permissions.edit_session_delete_notification"
                    class="deleteBtn f-c-c"
                    @click.prevent="deleteNoticeFunc(v)"
                  >
                    حذف
                  </div>
                  <!-- <b-img
                    v-if="
                      v.delete_flag &&
                      user.permissions.edit_session_delete_notification
                    "
                    @click.prevent="deleteNoticeFunc(v)"
                    class="ml-2 cp"
                    :src="require(`@/assets/images/gap/delete-icon.svg`)"
                  ></b-img> -->
                </div>
              </div>
            </div>
            <div v-else class="tableContent emptyTable f-c-c w-100 h-100">اطلاع رسانی وجود ندارد.</div>
            <div class="paginationSection f-c-c w-100">
              <b-pagination
                v-model="currentPage3"
                :total-rows="rows3"
                :per-page="perPage3"
                aria-controls="my-table"
              ></b-pagination>
            </div>
          </div>
          <div v-if="notices.length" class="mobileUserTable f-c-s f-d-c w-100 mb-3">
            <div v-for="(v, i) in notices" :key="i" class="tableItem f-c-s f-d-c w-100 mb-3">
              <div class="up f-c-b w-100 mb-3">
                <div class="right f-s-s f-d-c">
                  <div class="labelItem f-c-c mb-2">نوع :</div>
                  <div class="labelItem f-c-c mb-2">تاریخ ارسال :</div>
                  <div class="labelItem f-c-c mb-2">تعداد :</div>
                  <div class="labelItem f-c-c">وضعیت :</div>
                </div>
                <div class="left f-e-e f-d-c">
                  <div class="answerItem f-c-e mb-2">
                    {{ v ? v.send_type : "" }}
                  </div>
                  <div class="answerItem f-c-e mb-2">
                    {{ v ? v.send_date : "" }}
                  </div>
                  <div class="answerItem f-c-e mb-2">
                    {{ v ? v.count : "" }}
                  </div>
                  <div class="answerItem f-c-e">
                    {{ v ? v.status : "" }}
                  </div>
                </div>
              </div>
              <div class="down f-c-c w-100">
                <div
                  v-if="v.delete_flag && user.permissions.edit_session_delete_notification"
                  class="delete f-c-c"
                  @click.prevent="deleteNoticeFunc(v)"
                >
                  <b-img :src="require(`@/assets/images/mobile/delete-x.svg`)"></b-img>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="mobileUserTable tableContent emptyTable f-c-c w-100 h-100">
            اطلاع رسانی وجود ندارد.
          </div>
        </div>

        <div
          v-if="isActiveTab == 3"
          class="addUserBox addUserBoxStep2 addUserBoxStep2Mobile f-c-s f-d-c w-100 mb-2"
          style="padding: 10px 5px"
        >
          <div class="search-addUser pr-2 f-c-e w-100 mb-2">
            <div
              v-if="user.permissions.edit_session_edit_technology"
              @click.prevent="editTechnologyFunc()"
              class="addUser f-c-c"
            >
              <div class="text f-c-c" style="width: 96.58px; height: 30.5px">ویرایش</div>
            </div>
          </div>
          <div class="userTable meetTable technologyTable f-c-c f-d-c w-100">
            <div class="header f-c-s w-100">
              <div class="headerItem f-c-c">تکنولوژی</div>
              <div class="headerItem f-c-c">درخواست ضبط جلسه</div>
              <div class="headerItem f-c-c">قالب اختصاصی</div>
            </div>
            <div class="tableContent f-c-c f-d-c w-100">
              <div class="tableRow f-c-s w-100 mb-2">
                <div class="tableItem f-c-c" :class="[sessionInfo.technology ? 'green' : 'red']">
                  {{ sessionInfo.technology_title }}
                </div>
                <div class="tableItem f-c-c" :class="[sessionInfo.record ? 'green' : 'red']">
                  {{ sessionInfo.record ? "دارد" : "ندارد" }}
                </div>
                <div class="tableItem f-c-c" :class="[sessionInfo.landing_template ? 'green' : 'red']">
                  {{ sessionInfo.landing_template ? "دارد" : "ندارد" }}
                </div>
              </div>
            </div>
          </div>
          <div class="mobileUserTable f-c-s f-d-c w-100 mb-3">
            <div class="tableItem f-c-s f-d-c w-100 mb-3">
              <div class="up f-c-b w-100 mb-3">
                <div class="right f-s-s f-d-c">
                  <div class="labelItem f-c-c mb-2">تکنولوژی :</div>
                  <div class="labelItem f-c-c mb-2">درخواست ضبط جلسه :</div>
                  <div class="labelItem f-c-c">قالب اختصاصی :</div>
                </div>
                <div class="left f-e-e f-d-c">
                  <div class="answerItem f-c-e mb-2" :class="[sessionInfo.technology ? 'green' : 'red']">
                    {{ sessionInfo.technology_title }}
                  </div>
                  <div class="answerItem f-c-e mb-2" :class="[sessionInfo.record ? 'green' : 'red']">
                    {{ sessionInfo.record ? "دارد" : "ندارد" }}
                  </div>
                  <div class="answerItem f-c-e" :class="[sessionInfo.landing_template ? 'green' : 'red']">
                    {{ sessionInfo.landing_template ? "دارد" : "ندارد" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="isActiveTab == 4"
          class="addUserBox addUserBoxStep2 addUserBoxStep2Mobile f-c-s f-d-c w-100"
          style="padding: 10px 5px"
        >
          <div class="f-c-e search-addUser w-100 mb-3">
            <div
              v-if="user.permissions.edit_session_add_user"
              @click.prevent="addNewSupportFunc()"
              class="addUser f-c-c"
            >
              <span class="plus ml-2">+</span>
              <div class="text f-c-c">ثبت درخواست پشتیبانی</div>
            </div>
          </div>

          <div class="userTable sessionAddUser f-c-s f-d-c w-100 mb-3">
            <div class="header f-c-s w-100">
              <div class="headerItem f-c-s"></div>
              <div class="headerItem f-c-s">نوع</div>
              <div class="headerItem f-c-s">استان</div>
              <div class="headerItem f-c-s">شهر</div>
              <div class="headerItem f-c-s">تلفن</div>
              <div class="headerItem f-c-c">عملیات</div>
            </div>
            <div
              v-if="specialSupportData.support_requests && specialSupportData.support_requests.length"
              class="tableContent f-c-s f-d-c w-100"
            >
              <div
                class="tableRow f-c-s w-100"
                v-for="(v, i) in specialSupportData.support_requests"
                :key="i"
              >
                <div class="tableItem f-c-c">{{ i + 1 }}</div>
                <div class="tableItem f-c-s">
                  {{ v.support_type == "in_person" ? "حضوری" : v.support_type == "online" ? "آنلاین" : "-" }}
                </div>
                <div class="tableItem f-c-s">
                  {{ v.state ? v.state_title : "-" }}
                </div>
                <div class="tableItem f-c-s">
                  {{ v.city ? v.city_title : "-" }}
                </div>
                <div class="tableItem f-c-s">
                  {{ v.phone ? v.phone : "-" }}
                </div>

                <div class="tableItem f-c-sa">
                  <div
                    v-if="user.permissions.edit_session_edit_user"
                    class="editBtn f-c-c"
                    @click.prevent="editSupportFunc(v)"
                  >
                    ویرایش
                  </div>
                  <div
                    v-if="user.permissions.edit_session_deleteUser"
                    class="deleteBtn f-c-c"
                    @click.prevent="deleteSupportFunc(v)"
                  >
                    حذف
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="tableContent f-c-s f-d-c w-100 p-4 f-w-b">
              درخواست پشتیبانی ویژه وجود ندارد.
            </div>
          </div>
          <div
            v-if="specialSupportData.support_requests && specialSupportData.support_requests.length"
            class="mobileUserTable f-c-s f-d-c w-100 mb-3"
          >
            <div
              class="tableItem f-c-s f-d-c w-100 mb-3"
              v-for="(v, i) in specialSupportData.support_requests"
              :key="i"
            >
              <div class="up f-c-b w-100 mb-3">
                <div class="right f-s-s f-d-c">
                  <div class="labelItem f-c-c mb-2">نوع :</div>
                  <div class="labelItem f-c-c mb-2">استان :</div>
                  <div class="labelItem f-c-c mb-2">شهر :</div>
                  <div class="labelItem f-c-c">تلفن :</div>
                </div>
                <div class="left f-e-e f-d-c">
                  <div class="answerItem f-c-e mb-2">
                    {{
                      v.support_type == "in_person" ? "حضوری" : v.support_type == "online" ? "آنلاین" : "-"
                    }}
                  </div>
                  <div class="answerItem f-c-e mb-2">
                    {{ v.state ? v.state_title : "-" }}
                  </div>
                  <div class="answerItem f-c-e mb-2">
                    {{ v.city ? v.city_title : "-" }}
                  </div>
                  <div class="answerItem f-c-e mb-2">
                    {{ v.phone ? v.phone : "-" }}
                  </div>
                </div>
              </div>
              <div class="down f-c-b w-100">
                <div
                  v-if="user.permissions.edit_session_edit_user"
                  class="edit f-c-c"
                  @click.prevent="editSupportFunc(v)"
                >
                  <b-img :src="require(`@/assets/images/mobile/edit-pen.svg`)"></b-img>
                </div>
                <div
                  v-if="user.permissions.edit_session_deleteUser"
                  class="delete f-c-c"
                  @click.prevent="deleteSupportFunc(v)"
                >
                  <b-img :src="require(`@/assets/images/mobile/delete-x.svg`)"></b-img>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="mobileUserTable f-c-c w-100 f-w-b">درخواست پشتیبانی ویژه وجود ندارد.</div>
        </div>
      </div>
    </div>
    <div class="gapMaterial f-c-c w-100 p-4">
      <div class="text blueText f-c-c">
        کلیه حقوق مادی و معنوی متعلق به دانشگاه آزاد اسلامی واحد الکترونیکی می باشد.
      </div>
    </div>
    <b-modal
      id="addSans-modal"
      title="افزودن سانس جدید"
      button-size="sm"
      size="lg"
      :hide-footer="footer"
      ref="addSans-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="row satrt f-c-c w-100 mb-4">
          <div class="label f-c-s">عنوان</div>
          <div class="left f-c-s">
            <input v-model="sansTitle" @keyup="enterTitle" :maxlength="max" type="text" class="f-c-c w-100" />
          </div>
        </div>
        <div class="row f-c-c w-100 m-0 mb-3">
          <div class="tabSection f-c-b p-1">
            <div @click="isTabAvtive = 1" class="single f-c-c" :class="[isTabAvtive == 1 ? 'activeTab' : '']">
              تک جلسه ای
            </div>
            <div @click="isTabAvtive = 2" class="single f-c-c" :class="[isTabAvtive == 2 ? 'activeTab' : '']">
              چند جلسه ای
            </div>
          </div>
        </div>
        <div class="row f-c-c w-100 m-0 mb-4">
          <div class="tabContent f-c-s f-d-c p-3 mb-3">
            <div class="w-100 mb-3" :class="[isTabAvtive == 1 ? 'f-c-b single' : 'multi f-c-b']">
              <div class="right f-c-b" :class="[isTabAvtive == 1 ? 'w-48' : '']">
                <div class="label f-c-s">
                  {{ isTabAvtive == 1 ? "تاریخ" : "تاریخ شروع" }}
                </div>
                <div class="date f-c-s">
                  <b-img
                    class="title-icon ml-2"
                    :src="require(`@/assets/images/gap/calendar-icon.svg`)"
                  ></b-img>
                  <pdatepicker
                    v-model="startDate"
                    header-background-color="#125488"
                    hover-day-back-color="#8ebbdf"
                    chosen-day-back-color="#8ebbdf"
                    @selected="selectStartDate"
                    :placeholder="startDate ? startDate : ''"
                  ></pdatepicker>
                </div>
              </div>
              <div v-if="isTabAvtive == 2" class="left f-c-b">
                <div class="label f-c-c">تاریخ پایان</div>
                <div class="date f-c-s">
                  <b-img
                    class="title-icon ml-2"
                    :src="require(`@/assets/images/gap/calendar-icon.svg`)"
                  ></b-img>
                  <pdatepicker
                    :key="componentKey"
                    v-model="endDate"
                    dialog
                    class="endDateId"
                    header-background-color="#125488"
                    hover-day-back-color="#8ebbdf"
                    chosen-day-back-color="#8ebbdf"
                    :availableDates="dateTrue"
                    :availableDateStart="startDateLimit"
                    :placeholder="endDate ? endDate : ''"
                  ></pdatepicker>
                </div>
              </div>
            </div>
            <div class="timeSection f-c-b w-100 mb-3">
              <div class="right f-c-b">
                <div class="label f-c-c">ساعت شروع</div>
                <div class="time f-c-c">
                  <b-img class="title-icon ml-2" :src="require(`@/assets/images/gap/clock-icon.svg`)"></b-img>
                  <vue-timepicker
                    v-model="startTime"
                    drop-direction="up"
                    hour-label="ساعت"
                    minute-label="دقیقه"
                    placeholder="00:00"
                  ></vue-timepicker>
                </div>
              </div>
              <div class="left f-c-b">
                <div class="label f-c-c">ساعت پایان</div>
                <div class="time f-c-c">
                  <b-img class="title-icon ml-2" :src="require(`@/assets/images/gap/clock-icon.svg`)"></b-img>
                  <vue-timepicker
                    v-model="endTime"
                    drop-direction="up"
                    hour-label="ساعت"
                    minute-label="دقیقه"
                    placeholder="00:00"
                  ></vue-timepicker>
                </div>
              </div>
            </div>
            <!-- <div v-if="isTabAvtive == 2" class="row f-s-c w-100 mb-2 mt-3">
              <div class="multi-table w-100">
                <div class="table-header w-100">
                  <div
                    class="header-item"
                    v-for="(v, i) in days2"
                    :key="i"
                    style="color: #212529"
                  >
                    {{ v.title }}
                  </div>
                </div>
                <div class="table-content w-100 h-100">
                  <div
                    class="body-item"
                    v-for="(v, i) in days2"
                    :key="i"
                    style="color: #212529"
                  >
                    <div
                      v-for="(d, j) in selectDaysList[i]"
                      :key="j"
                      class="sansItem f-d-c"
                      @mouseover="ishover = i + '-' + j"
                      @mouseleave="ishover = null"
                      :class="[ishover == i + '-' + j ? 'f-c-c' : 'f-c-sa']"
                    >
                      <div class="text f-c-c w-100">
                        {{ d.start + " الی " + d.end }}
                      </div>
                      <div v-if="ishover == i + '-' + j" class="f-c-c w-100">
                        <b-img
                          @click.prevent="editSansDayFunc(d, j, i)"
                          class="ml-2"
                          :src="require(`@/assets/images/gap/edit-icon.svg`)"
                        ></b-img>
                        <b-img
                          @click.prevent="deleteSansDayFunc(d, j, i)"
                          :src="require(`@/assets/images/gap/delete-icon.svg`)"
                        ></b-img>
                      </div>
                    </div>
                    <div
                      @click="finallAddNewSansFunc(i)"
                      class="add-sans f-c-c"
                    >
                      +
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <div v-if="isTabAvtive == 2" class="selectDay f-c-b w-100 mb-4">
              <div class="label f-c-s">انتخاب روز</div>
              <div class="dayBox f-c-b f-w-w">
                <div
                  v-for="(v, i) in days2"
                  :key="i"
                  class="day f-c-c"
                  @click="selectDayFunc(v)"
                  :class="[isactive.includes(v.value) ? 'active' : '']"
                >
                  {{ v.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btnSec w-100 f-c-c">
          <div class="finalbtn f-c-c m-0" @click="addSansFinalBtn()">ثبت</div>
        </div>
      </template>
    </b-modal>
    <b-modal id="addSans-modal" title="ویرایش" button-size="sm" :hide-footer="footer" ref="editSans-modal">
      <template class="content f_s_s f-d-c w-100">
        <div class="row satrt f-c-c w-100 mb-3">
          <div class="label f-c-s">عنوان</div>
          <div class="left f-c-s">
            <input v-model="sansTitle" type="text" class="f-c-c w-100" />
          </div>
        </div>

        <div class="row satrt f-c-c w-100 mb-3">
          <div class="label f-c-s">تاریخ شروع</div>
          <div class="left f-c-b">
            <div class="date f-c-s w-100">
              <b-img class="title-icon ml-2" :src="require(`@/assets/images/gap/calendar-icon.svg`)"></b-img>
              <pdatepicker
                v-model="startDate"
                header-background-color="#125488"
                hover-day-back-color="#8ebbdf"
                chosen-day-back-color="#8ebbdf"
                @selected="selectStartDate"
                :placeholder="startDate"
              ></pdatepicker>
            </div>
          </div>
        </div>
        <div class="row end f-c-c w-100 mb-4">
          <div class="label f-c-s">زمان</div>
          <div class="left f-c-b">
            <!-- <div class="date f-c-s">
              <b-img
                class="title-icon ml-2"
                :src="require(`@/assets/images/gap/calendar-icon.svg`)"
              ></b-img>
              <pdatepicker
                :key="componentKey"
                v-model="endDate"
                header-background-color="#439889"
                hover-day-back-color="#439889"
                chosen-day-back-color="#439889"
                :availableDates="dateTrue"
                :availableDateStart="startDateLimit"
                :placeholder="endDate"
              ></pdatepicker>
            </div> -->
            <div class="time f-c-c w-48">
              <b-img class="title-icon ml-2" :src="require(`@/assets/images/gap/clock-icon.svg`)"></b-img>
              <vue-timepicker
                v-model="startTime"
                drop-direction="auto"
                hour-label="ساعت"
                minute-label="دقیقه"
                placeholder="00:00"
              ></vue-timepicker>
            </div>
            <div class="time f-c-c w-48">
              <b-img class="title-icon ml-2" :src="require(`@/assets/images/gap/clock-icon.svg`)"></b-img>
              <vue-timepicker
                v-model="endTime"
                drop-direction="auto"
                hour-label="ساعت"
                minute-label="دقیقه"
                :hour-range="hourRange"
                :minute-range="minuteRange"
                placeholder="00:00"
              ></vue-timepicker>
            </div>
          </div>
        </div>
        <!-- <div class="row f-c-c w-100 mb-4">
          <div class="label f-c-s">جنسیت</div>
          <select class="repeatPeriod" v-model="gender">
            <option v-for="(v, i) in genders" :key="i" :value="v.value">
              {{ v ? v.name : "" }}
            </option>
          </select>
        </div> -->
        <div class="btnSec w-100 f-c-c">
          <div class="finalbtn f-c-c m-0" @click="addSansFinalBtn()">ثبت</div>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="addSans-modal"
      title="ویرایش قالب اختصاصی"
      button-size="sm"
      :hide-footer="footer"
      ref="editTechnology-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <!-- <div class="row tRow satrt f-c-c w-100 mb-4">
          <div class="label f-c-s">تکنولوژی</div>
          <div class="left f-c-b">
            <select class="repeatPeriod" v-model="technologyType">
              <option
                v-for="(v, i) in allTec.information"
                :key="i"
                :value="v.id"
              >
                {{ v.title ? v.title : "" }}
              </option>
            </select>
          </div>
        </div> -->
        <div class="row tRow end f-c-c w-100 mb-4">
          <div class="label f-c-s">درخواست ضبط جلسه</div>
          <div class="left f-c-b">
            <div class="recordSection f-c-b w-100">
              <div
                @click="selectRecorcStatusFunc(1)"
                class="have f-c-c"
                :class="[isrecordStatus == 1 ? 'active' : '']"
              >
                دارم
              </div>
              <div
                @click="selectRecorcStatusFunc(0)"
                class="have f-c-c"
                :class="[isrecordStatus == 0 ? 'active' : '']"
              >
                ندارم
              </div>
            </div>
          </div>
        </div>
        <div class="row tRow end f-s-c w-100 mb-4">
          <div class="label f-c-s">قالب اختصاصی</div>
          <div class="left f-c-b f-d-c">
            <textarea class="mb-2" v-model="technologyText"></textarea>
            <div class="logoSection f-c-b w-100 mb-4">
              <div class="logo f-c-c f-d-c">
                <b-img v-if="cropped" class="title-icon mb-1" :src="cropped"></b-img>
                <b-img
                  v-else
                  class="title-icon mb-1"
                  :src="
                    logoFile && logoFile.name
                      ? logoFile.name
                      : require(`@/assets/images/gap/picture-icon.svg`)
                  "
                ></b-img>
                <div class="changeLogo w-100 f-c-b">
                  <input id="logoFileInput" class="d-none" type="file" @change="croppie" />
                  <div class="selectLogo f-c-c" @click="selectLogoFunc()">انتخاب لوگو</div>
                  <vue-croppie
                    class="d-n-w-h-0"
                    ref="croppieRef"
                    :enableResize="false"
                    :enableOrientation="true"
                  >
                  </vue-croppie>
                  <b-img
                    v-if="(logoFile && logoFile.name) || cropped"
                    @click.prevent="deleteLogoFunc()"
                    class=""
                    :src="require(`@/assets/images/gap/delete.svg`)"
                  ></b-img>
                </div>
              </div>
              <div class="logo f-c-c f-d-c">
                <b-img v-if="cropped1" class="title-icon mb-1" :src="cropped1"></b-img>
                <b-img
                  v-else
                  class="title-icon mb-1"
                  :src="
                    photoFile && photoFile.name
                      ? photoFile.name
                      : require(`@/assets/images/gap/picture-icon.svg`)
                  "
                ></b-img>

                <div class="changeLogo w-100 f-c-b">
                  <input
                    id="banerFileInput"
                    accept="image/gif, image/jpeg, image/png"
                    class="d-none"
                    type="file"
                    @change="croppie1"
                  />
                  <div class="selectLogo f-c-c" @click="selectBanerFunc()">انتخاب بنر</div>
                  <vue-croppie
                    class="d-n-w-h-0"
                    ref="croppieRef"
                    :enableResize="false"
                    :enableOrientation="true"
                  >
                  </vue-croppie>

                  <b-img
                    v-if="(photoFile && photoFile.name) || cropped1"
                    @click.prevent="deleteBanerFunc()"
                    class=""
                    :src="require(`@/assets/images/gap/delete.svg`)"
                  ></b-img>
                </div>
              </div>
            </div>
            <!-- <div class="UrlAddsress f-c-c mb-3">
              <div class="right f-c-c">آدرس</div>
              <input type="text" class="deskUrl" v-model="url" />
              <div class="left f-c-c">https://vadaroom.ec.iau.ir/v/</div>
              <input type="text" class="mobileUrl" v-model="url" />
            </div> -->
          </div>
        </div>
        <div class="btnSec w-100 f-c-c">
          <div class="finalbtn f-c-c" @click="editTechnologyFinalFunc()">ذخیره</div>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="addSans-modal"
      title="ضبط شده ها"
      modal-class="detailsRecord"
      button-size="sm"
      size="lg"
      :hide-footer="footer"
      ref="records-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="userTable f-c-c f-d-c w-100">
          <div class="header f-c-s w-100 mb-2">
            <div class="headerItem f-c-s"></div>
            <div class="headerItem f-c-s">عنوان</div>
            <div class="headerItem f-c-s">وضعیت</div>
          </div>
          <div v-if="itemsForList4.length" class="tableContent f-c-c f-d-c w-100">
            <div v-for="(v, i) in itemsForList4" :key="i" class="tableRow f-c-s w-100 mb-2">
              <div class="tableItem f-c-c">{{ v.row }}</div>
              <div class="tableItem f-c-s">
                <a :href="v.url" target="_blank" class="f-c-c">
                  {{ v ? v.name : "-" }}
                </a>
              </div>
              <div class="tableItem f-c-s">
                <select class="repeatPeriod ml-2" v-model="recordStatus[i]" @change="recordStatusFunc(i)">
                  <option
                    v-for="(g, j) in allStatus.information"
                    :key="j"
                    :value="g.id + '/' + v.id + '/' + i"
                  >
                    {{ g ? g.title : "" }}
                  </option>
                </select>
                <div class="deleteBtn f-c-c" @click.prevent="deleteRecordFunc(v)">حذف</div>
              </div>
            </div>
          </div>
          <div v-else class="tableContent emptyTable f-c-c w-100 h-100">ضبط شده ای وجود ندارد.</div>
          <div class="paginationSection f-c-c w-100">
            <b-pagination
              v-model="currentPage4"
              :total-rows="rows4"
              :per-page="perPage4"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </div>
      </template>
    </b-modal>

    <!-- Notices Modal -->
    <b-modal
      id="notices-modal"
      title="اطلاع رسانی جدید"
      button-size="sm"
      :hide-footer="footer"
      ref="notices-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="row ml-0 mr-0 f-c-c w-100 mb-3">
          <div class="label f-c-s">سانس</div>
          <select class="noticeType" v-model="sans">
            <option v-for="(v, i) in allActiveSansVal" :key="i" :value="v.id">
              {{ v.title }}
            </option>
          </select>
        </div>
        <div class="row ml-0 mr-0 f-c-c w-100 mb-3">
          <div class="label f-c-s">نوع</div>
          <select class="noticeType" v-model="notice.type">
            <option v-for="(v, i) in allType.information" :key="i" :value="v">
              {{ v ? v.title : "" }}
            </option>
          </select>
        </div>
        <div class="row ml-0 mr-0 f-c-c w-100 mb-3">
          <div class="label f-c-s">موضوع</div>
          <select class="subject" @input="selectSubjectFunc" v-model="notice.subject">
            <option v-for="(v, i) in getAllSansSubjectStatus.subjects" :key="i" :value="v">
              {{ v ? v.title : "" }}
            </option>
          </select>
        </div>
        <div class="row ml-0 mr-0 f-c-c w-100 mb-3">
          <div class="label f-c-s">متن</div>
          <textarea v-html="notice.description" disabled></textarea>
        </div>
        <div class="row ml-0 mr-0 end f-c-c w-100 mb-4">
          <div class="label f-c-s">زمان</div>
          <div class="left f-c-b">
            <div class="date f-c-s">
              <b-img class="title-icon ml-2" :src="require(`@/assets/images/gap/calendar-icon.svg`)"></b-img>
              <pdatepicker
                v-model="notice.date"
                header-background-color="#125488"
                hover-day-back-color="#8ebbdf"
                chosen-day-back-color="#8ebbdf"
                placeholder=""
              ></pdatepicker>
            </div>
            <div class="time f-c-c">
              <b-img class="title-icon ml-2" :src="require(`@/assets/images/gap/clock-icon.svg`)"></b-img>
              <vue-timepicker
                v-model="notice.time"
                drop-direction="auto"
                hour-label="ساعت"
                minute-label="دقیقه"
                placeholder="00:00"
              ></vue-timepicker>
            </div>
          </div>
        </div>
        <div class="btnSec w-100 f-c-c">
          <div class="finalbtn f-c-c" @click="addNoticeForSansFunc()">ذخیره</div>
        </div>
      </template>
    </b-modal>
    <!-- End Notices Modal -->
    <b-modal id="edit-modal" title="ویرایش" button-size="sm" :hide-footer="footer" ref="edit-modal">
      <template class="content f_s_s f-d-c w-100">
        <div class="row f-c-c w-100 mb-3">
          <div class="label f-c-s">نام</div>
          <input v-model="editUser.name" type="text" />
        </div>
        <div class="row f-c-c w-100 mb-3">
          <div class="label f-c-s">نام خانوادگی</div>
          <input v-model="editUser.family" type="text" />
        </div>
        <div class="row f-c-c w-100 mb-3">
          <div class="label f-c-s">موبایل</div>
          <input v-model="editUser.mobile" type="number" />
        </div>
        <!-- <div class="row f-c-c w-100 mb-3">
          <div class="label f-c-s">ایمیل</div>
          <input v-model="editUser.email" type="email" />
        </div> -->
        <div class="row f-c-c w-100 mb-4">
          <div class="label f-c-s">نقش</div>
          <select class="gender" v-model="editUser.role">
            <option v-for="(v, i) in allRole.information" :key="i" :value="v.id">
              {{ v.title ? v.title : "" }}
            </option>
          </select>
        </div>
        <div class="btnSec w-100 f-c-c">
          <div class="finalbtn f-c-c" @click="editUserFinalBtn()">ذخیره</div>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="add-modal"
      title="افزودن کاربر"
      button-size="sm"
      size="lg"
      :hide-footer="footer"
      ref="add-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="addUserBox f-c-s f-d-c w-100 h-100">
          <div class="header f-c-b w-100">
            <div
              v-for="(v, i) in headerItem"
              :key="i"
              class="item f-c-c w-32"
              @click.prevent="activeId = i"
              :class="[activeId == i ? 'active' : '']"
            >
              {{ v }}
            </div>
          </div>
          <div v-if="activeId == 0" class="singleSec f-c-c f-d-c w-100">
            <div class="row f-c-c w-100 mb-3">
              <div class="label f-c-s">موبایل</div>
              <input v-model="addUser.mobile" type="number" />
            </div>
            <div class="row f-c-c w-100 mb-3">
              <div class="label f-c-s">نام</div>
              <input v-model="addUser.name" type="text" />
            </div>
            <div class="row f-c-c w-100 mb-3">
              <div class="label f-c-s">نام خانوادگی</div>
              <input v-model="addUser.family" type="text" />
            </div>
            <!-- <div class="row f-c-c w-100 mb-3">
              <div class="label f-c-s">ایمیل</div>
              <input v-model="addUser.email" type="email" />
            </div> -->
            <div class="row f-c-c w-100 mb-4">
              <div class="label f-c-s">نقش</div>
              <select class="gender" v-model="addUser.role">
                <option v-for="(v, i) in allRole.information" :key="i" :value="v.id">
                  {{ v.title ? v.title : "" }}
                </option>
              </select>
            </div>
            <div class="btnSec w-100 f-c-c">
              <div class="finalbtn f-c-c" @click="addUserSingleFinalBtn()">ذخیره</div>
            </div>
          </div>
          <div v-if="activeId == 1" class="singleSec f-c-c f-d-c w-100 h-100">
            <div class="row f-c-c w-100 mb-5">
              <div class="label f-c-s">عنوان</div>
              <select class="gender" v-model="groupTitle">
                <option v-for="(v, i) in allUserGroup.user_groups" :key="i" :value="v">
                  {{ v.title }}
                </option>
              </select>
            </div>
            <div class="btnSec w-100 f-c-c">
              <div class="finalbtn f-c-c" @click="saveUserWithGroupFunc()">ذخیره</div>
            </div>
          </div>
          <div v-if="activeId == 2" class="singleSec f-c-s f-d-c w-100">
            <div class="dragSection f-c-c w-50 mb-4">
              <b-form-group id="fileInputForum" class="dragdrop m-0 f-c-c f-d-c w-100 h-100">
                <b-form-file
                  accept=".xlsx, .xls"
                  drop-placeholder="رها کنید"
                  ref="excel-input"
                  @input="addFileFunc"
                >
                  <template slot="placeholder">
                    <b-img :src="require(`@/assets/images/gap/excel-icon.svg`)"></b-img>
                    <div class="text f-c-c">
                      <div class="plus ml-2">+</div>
                      <div class="value f-c-c" style="color: #125488">
                        {{ "افزودن فایل اکسل" }}
                      </div>
                    </div>
                  </template>
                  <template slot="file-name">
                    <b-img :src="require(`@/assets/images/gap/excel-icon.svg`)"></b-img>
                    <div class="text f-c-c">
                      <div class="plus ml-2">+</div>
                      <div class="value f-c-c">
                        {{ "افزودن فایل اکسل" }}
                      </div>
                    </div>
                  </template>
                </b-form-file>
              </b-form-group>
            </div>
            <div class="sampleExcel f-c-c w-100">
              <a
                class="sampleExcel f-c-c mb-4"
                :href="require(`@/assets/excel/sample_session_user.xlsx`)"
                download
                >دانلود نمونه فایل اکسل</a
              >
            </div>
            <div class="btnSec excelBtn w-100 f-c-c mb-1">
              <div class="finalbtn f-c-c" @click="addUserExcellFinalBtn()">ذخیره</div>
            </div>
            <div v-if="addUser.file && addUser.file.name" class="fileList">
              <div class="fileList-item f_c_c">
                <a href="#" class="value">{{ addUser.file.name }}</a>
                <span class="close-btn mr-2" @click.prevent="deleteFileFunc()">&times;</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
    <!-- addSupport-modal__MeySam -->
    <b-modal
      id="add-modal"
      title="درخواست پشتیبانی"
      button-size="sm"
      :hide-footer="footer"
      ref="addSupport-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="radioSection f-c-c f-d-c w-100 h-fit p-3">
          <div class="f-c-c w-100">
            <div class="radio active">
              <input v-model="special_support_radio" id="radio-1" name="radio" type="radio" value="online" />
              <label for="radio-1" class="radio-label">آنلاین</label>
            </div>

            <div class="radio active">
              <input
                v-model="special_support_radio"
                id="radio-2"
                name="radio"
                type="radio"
                value="in_person"
              />
              <label for="radio-2" class="radio-label">حضوری</label>
            </div>
          </div>

          <div
            v-if="special_support_radio == 'in_person' || special_support_radio == 'online'"
            class="selectCity f-s-s f-d-c w-100 mb-2"
          >
            <div class="label f-c-s">سانس</div>
            <v-select
              v-model="selectSansSupport"
              @input="setSelectedSansSupport"
              :options="allActiveSansVal"
              :reduce="(option) => option.id"
              label="title"
              ref="selectSansSupport"
            >
              <span slot="no-options" @click="$refs.selectSansSupport.open = false"> موردی یافت نشد. </span>
            </v-select>
          </div>

          <div v-if="special_support_radio == 'in_person'" class="selectCity f-s-s f-d-c w-100 mb-2">
            <div class="label f-c-s">
              استان
              <span>(فعلا فقط تهران)</span>
            </div>
            <v-select
              v-model="selectState"
              @input="setSelectedState"
              :title="stateTitle"
              :options="allState.information"
              :reduce="(option) => option.id"
              label="title"
              ref="selectState">
              <span slot="no-options" @click="$refs.selectState.open = false"> موردی یافت نشد. </span>
            </v-select>
          </div>

          <div
            v-if="special_support_radio == 'in_person'"
            class="selectCity mb-2 w-100 selectCity-w-767 f-s-s f-d-c"
          >
            <div class="label f-c-s">
              شهر
              <span>(فعلا فقط تهران)</span>
            </div>
            <v-select
              v-model="selectCity"
              @input="setSelected"
              :title="organizationTitle"
              :options="cityList"
              :reduce="(option) => option.id"
              label="title"
              ref="selectCity"
            >
              <span slot="no-options" @click="$refs.selectCity.open = false"> موردی یافت نشد. </span>
            </v-select>
          </div>

          <div
            v-if="special_support_radio == 'in_person'"
            class="selectCity mb-2 w-100 selectCity-w-767 f-s-s f-d-c"
          >
            <div class="label f-c-s">تلفن</div>
            <input v-model="phone" class="w-100" type="number" />
          </div>

          <div
            v-if="special_support_radio == 'in_person'"
            class="selectCity mb-2 w-100 selectCity-w-767 f-s-s f-d-c mb-3"
          >
            <div class="label f-c-s">آدرس</div>
            <textarea v-model="address"></textarea>
          </div>

          <!-- <div
            v-if="special_support_radio == 'in_person'"
            class="f-c-s technicalEquipment w-100 pt-1 pb-2 mb-3"
          >
            <div class="checkboxSec f-s-s w-100 h-fit">
              <input
                type="checkbox"
                class="visfire"
                v-model="technical_equipment"
                value="technical_equipment"
                id="c777"
                name="cbd"
              />
              <label for="c777" style="margin-right: 0.3rem">درخواست تجهیزات فنی </label>
            </div>
          </div> -->

          <div
            class="addSupportBtnSec f-c-c w-100"
            :class="[special_support_radio == 'in_person' ? 'mt-1' : 'mt-4']"
          >
            <div
              @click="special_support_radio ? setSpecialSupportFunc() : ''"
              class="addSupportBtn f-c-c"
              :class="[special_support_radio ? '' : 'disableSupportBtn']"
            >
              ثبت
            </div>
          </div>
        </div>
      </template>
    </b-modal>
    <!-- addSupport-modal__MeySam -->
    <b-modal
      id="edit-modal"
      :title="isSansEdit ? 'ویرایش' : 'افزودن زمان جدید'"
      button-size="sm"
      :hide-footer="footer"
      ref="addDaySans-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="row f-c-s w-100 m-0 mb-4 mt-3">
          <div class="label f-c-s w-fit ml-2">روز</div>
          <div class="left f-c-b w-50">
            <select class="sessionGroup w-100" v-model="selectedDay" :disabled="isSansEdit">
              <option v-for="(v, i) in days2" :key="i" :value="v.id">
                {{ v.fullTitle }}
              </option>
            </select>
          </div>
        </div>
        <div class="row f-c-s w-100 m-0 mb-4">
          <div class="timeSection f-c-b w-100 mb-3">
            <div class="right f-c-b">
              <div class="label f-c-c">ساعت شروع</div>
              <div class="time f-c-c">
                <b-img class="title-icon ml-2" :src="require(`@/assets/images/gap/clock-icon.svg`)"></b-img>
                <vue-timepicker
                  v-model="multistartTime"
                  drop-direction="up"
                  hour-label="ساعت"
                  minute-label="دقیقه"
                  placeholder="00:00"
                ></vue-timepicker>
              </div>
            </div>
            <div class="left f-c-b">
              <div class="label f-c-c">ساعت پایان</div>
              <div class="time f-c-c">
                <b-img class="title-icon ml-2" :src="require(`@/assets/images/gap/clock-icon.svg`)"></b-img>
                <vue-timepicker
                  v-model="multiendTime"
                  format="HH:mm"
                  drop-direction="up"
                  hour-label="ساعت"
                  minute-label="دقیقه"
                  placeholder="00:00"
                ></vue-timepicker>
              </div>
            </div>
          </div>
        </div>

        <div class="btnSec w-100 f-c-c mb-3">
          <div class="finalbtn f-c-c" @click="saveSansFunc()">
            {{ isSansEdit ? "ویرایش" : "ذخیره" }}
          </div>
        </div>
      </template>
    </b-modal>
    <DeleteConfirm v-if="isLogoDelete" message="از حذف لوگو مطمئن هستید ؟" />
    <DeleteConfirm v-if="isPhotoDelete" message="از حذف عکس مطمئن هستید ؟" />
    <DeleteConfirm v-if="isDelete" message="از حذف کاربر مطمئن هستید ؟" />
    <DeleteConfirm v-if="isRecordDelete" message="از حذف مطمئن هستید ؟" />
    <DeleteConfirm v-if="isDeleteSupport" message="از حذف پشتیبانی مطمئن هستید ؟" />
    <DeleteConfirm v-if="isSunsDelete" message="از حذف سانس مطمئن هستید ؟" />
    <DeleteConfirm v-if="isNoticeDelete" message="از حذف اطلاع رسانی مطمئن هستید ؟" />
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import DeleteConfirm from "@/components/DelConfirmModal";
import { EventBus } from "@/assistant/EventBus";
export default {
  name: "SessionDetails",
  data() {
    return {
      max: 30,
      days2: [
        { id: 0, title: "ش", fullTitle: "شنبه", value: "saturday" },
        { id: 1, title: "ی", fullTitle: "یکشنبه", value: "sunday" },
        { id: 2, title: "د", fullTitle: "دوشنبه", value: "monday" },
        { id: 3, title: "س", fullTitle: "سه شنبه", value: "tuesday" },
        { id: 4, title: "چ", fullTitle: "چهارشنبه", value: "wednesday" },
        { id: 5, title: "پ", fullTitle: "پنجشنبه", value: "thursday" },
        { id: 6, title: "ج", fullTitle: "جمعه", value: "friday" },
      ],
      selectDaysList: [[], [], [], [], [], [], []],
      technical_equipment: [],
      title: "",
      capacity: "",
      address: "",
      organizationTitle: "",
      stateTitle: "",
      phone: "",
      userOrg: "",
      sessionGroup: "",
      cityList: [],
      stateList: [],
      special_support_radio: "",
      sansTitle: "",
      guestStatus: "",
      isEditSans: false,
      isSansEdit: false,
      selectedDay: 0,
      selectedDaySansId: 0,
      ishover: null,
      cropped: null,
      cropped1: null,
      isActiveTab: 0,
      recordStatusIndex: 0,
      minuteRange: [],
      sansRecordsList: [],
      mobileSansRecordsList: [],
      sansRecord: {},
      hourRange: [],
      groupTitle: "",
      searchUser: "",
      searchSans: "",
      editSansId: "",
      startDate: "",
      startDateLimit: "",
      selectCity: "",
      selectState: "",
      dateTrue: true,
      componentKey: 0,
      endDate: "",
      startTime: "00:00",
      endTime: "00:00",
      multistartTime: "00:00",
      multiendTime: "00:00",
      technologyType: "",
      technologyText: "",
      gender: "all",
      sansSelectedId: "",
      statusVal: "active",
      notice: {
        type: "",
        subject: "",
        description: "",
        time: "00:00",
        date: "",
      },
      sans: "",
      isTabAvtive: 1,
      isactive: [],
      genders: [
        { id: 1, name: "زن", value: "female" },
        { id: 2, name: "مرد", value: "male" },
        { id: 3, name: "هردو", value: "all" },
      ],
      statusList: [
        { id: "active", title: "فعال" },
        { id: "unactive", title: "غیرفعال" },
      ],
      recordList: [
        { id: 1, row: 1, title: "فعال" },
        { id: 2, row: 2, title: "غیرفعال" },
      ],
      users: [],
      sanses: [],
      allActiveSansVal: [],
      notices: [],
      url: "",
      role: "",
      recordStatus: [],
      actionList: [
        { id: 1, title: "ویرایش" },
        { id: 2, title: "حذف" },
      ],
      isNoticeDelete: false,
      isSearchUserActive: false,
      isSearchSansActive: false,
      noticeDeleted: {},
      currentPage: 1,
      perPage: 15,
      currentPage2: 1,
      perPage2: 15,
      currentPage3: 1,
      perPage3: 15,
      currentPage4: 1,
      perPage4: 15,
      isrecordStatus: 0,
      footer: true,
      isDelete: false,
      isDeleteSupport: false,
      isRecordDelete: false,
      isSunsDelete: false,
      isLogoDelete: false,
      isPhotoDelete: false,
      chlogo: {},
      chphoto: {},
      isEdit: false,
      isEditSupport: false,
      userDeleted: {},
      recordDeleted: {},
      selectRow: {},
      supportEdited: {},
      sunsDeleted: {},
      userEdited: {},
      logoFile: {},
      photoFile: {},
      activeId: 0,
      editUser: {
        name: "",
        family: "",
        email: "",
        mobile: "",
        role: "",
      },
      editSupport: {
        name: "",
        family: "",
        email: "",
        mobile: "",
        role: "",
      },
      headerItem: ["تکی", "گروهی", "اکسلی"],
      addUser: {
        name: "",
        family: "",
        email: "",
        mobile: "",
        role: "",
        file: {},
      },
      guestList: [
        { id: 0, value: "not_allowed", status: false, title: "ندارد" },
        {
          id: 1,
          value: "by_host_permission",
          status: true,
          title: "با اجازه مدیر جلسه",
        },
        {
          id: 2,
          value: "no_permission",
          status: true,
          title: "بدون نیاز به اجازه مدیر جلسه",
        },
      ],
      selectSansSupport: "",
      isSansInNotify: false,
      sans_id: 0,
      supportDeleted: {},
    };
  },
  created() {
    this.getAllStateFunction({
      user_id: this.user.user_id,
      type_id: "2",
      parent_id: "0",
    });
    this.getAllUsersGroupFunction({
      user_id: this.user.user_id,
    });
    this.getAllUserOrgFunction({
      user_id: this.user.user_id,
    });
    this.getAllRoleFunction({
      user_id: this.user.user_id,
    });
    this.getSessionUsersFunction({
      user_id: this.user.user_id,
      session_id: this.sessionInfo.id,
    });
    this.getAllSansFunction({
      user_id: this.user.user_id,
      session_id: this.sessionInfo.id,
    });
    this.getSessionNotificationsFunction({
      user_id: this.user.user_id,
      session_id: this.sessionInfo.id,
    });
    this.getSpecialSupportFunction({
      user_id: this.user.user_id,
      session_id: this.sessionInfo.id,
    });
    this.getAllSessionGroupsFunction({
      user_id: this.user.user_id,
    });
    this.getAllTecFunction({
      user_id: this.user.user_id,
    });
    this.getAllTypeFunction({
      user_id: this.user.user_id,
    });
    this.getAllRecorStatusFunction({
      user_id: this.user.user_id,
    });
    EventBus.$on("deleteItem", (status) => {
      if (status) {
        if (this.isDelete) {
          this.deleteUserOfSessionFunction({
            user_id: this.user.user_id,
            session_user_id: this.userDeleted.session_user_id,
          });
          this.isDelete = false;
        } else if (this.isSunsDelete) {
          this.deleteSessionSansFunction({
            user_id: this.user.user_id,
            session_sans_id: this.sunsDeleted.id,
          });
          this.isSunsDelete = false;
        } else if (this.isNoticeDelete) {
          this.deleteSessionNotificationFunction({
            user_id: this.user.user_id,
            notification_id: this.noticeDeleted.id,
          });
          this.isNoticeDelete = false;
        } else if (this.isLogoDelete) {
          this.sessionPhotoDeleteFunction({
            user_id: this.user.user_id,
            section: "session",
            section_id: this.sessionInfo.id,
            subject: "logo",
          });
          this.logoFile = {};
          this.cropped = null;
          this.isLogoDelete = false;
        } else if (this.isDeleteSupport) {
          this.deletespecialSupportFunction({
            user_id: this.user.user_id,
            session_id: this.sessionInfo.id,
            support_id: this.supportDeleted.support_id,
          });
          this.isDeleteSupport = false;
        } else if (this.isRecordDelete) {
          this.deleteRecordSessionFunction({
            user_id: this.user.user_id,
            recording_id: this.recordDeleted.id,
          });
          this.isRecordDelete = false;
        } else {
          this.sessionPhotoDeleteFunction({
            user_id: this.user.user_id,
            section: "session",
            section_id: this.sessionInfo.id,
            subject: "banner",
          });
          this.photoFile = {};
          this.cropped1 = null;
          this.isPhotoDelete = false;
        }
      } else {
        this.isDelete = false;
        this.isDeleteSupport = false;
        this.isSunsDelete = false;
        this.isNoticeDelete = false;
        this.isLogoDelete = false;
        this.isPhotoDelete = false;
        this.isRecordDelete = false;
      }
    });
  },
  components: {
    DeleteConfirm,
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
      allUserGroup: (state) => state.gap.allUserGroup,
      allSessionGroups: (state) => state.gap.allSessionGroups,
      sessionInfo: (state) => state.gap.sessionInfo,
      allTec: (state) => state.gap.allTec,
      allType: (state) => state.gap.allType,
      allStatus: (state) => state.gap.allStatus,
      allRole: (state) => state.gap.allRole,
      sessionUsers: (state) => state.gap.sessionUsers,
      editUserInSessionStatus: (state) => state.gap.editUserInSessionStatus,
      deleteUserOfSessionStatus: (state) => state.gap.deleteUserOfSessionStatus,
      sessionNotifications: (state) => state.gap.sessionNotifications,
      allSans: (state) => state.gap.allSans,
      addSansInSessionStatus: (state) => state.gap.addSansInSessionStatus,
      editSansInSessionStatus: (state) => state.gap.editSansInSessionStatus,
      deleteSessionSansStatus: (state) => state.gap.deleteSessionSansStatus,
      getSansRecordsStatus: (state) => state.gap.getSansRecordsStatus,
      setRecordingPolicyStatus: (state) => state.gap.setRecordingPolicyStatus,
      getAllSansSubjectStatus: (state) => state.gap.getAllSansSubjectStatus,
      addNoticeForSansStatus: (state) => state.gap.addNoticeForSansStatus,
      allActiveSans: (state) => state.gap.allActiveSans,
      editSessionStatus: (state) => state.gap.editSessionStatus,
      sessionPhotoDeleteStatus: (state) => state.gap.sessionPhotoDeleteStatus,
      addUserGroupSessionStatus: (state) => state.gap.addUserGroupSessionStatus,
      checkUrlStatus: (state) => state.gap.checkUrlStatus,
      setIsGroupMeets: (state) => state.gap.setIsGroupMeets,
      specialSupportData: (state) => state.gap.specialSupportData,
      addSpecialSupportStatus: (state) => state.gap.addSpecialSupportStatus,
      detailsTabIndex: (state) => state.gap.detailsTabIndex,
      deleteRecordSessionStatus: (state) => state.gap.deleteRecordSessionStatus,
      allCities: (state) => state.gap.allCities,
      allState: (state) => state.gap.allState,
      deletespecialSupportStatus: (state) => state.gap.deletespecialSupportStatus,
      allUserOrg: (state) => state.gap.allUserOrg,
      deleteSessionNotificationStatus: (state) => state.gap.deleteSessionNotificationStatus,
      addUserWithExcelSessionStatus: (state) => state.gap.addUserWithExcelSessionStatus,
      addUserSingleSessionStatus: (state) => state.gap.addUserSingleSessionStatus,
    }),
    rows() {
      return this.users.length;
    },
    itemsForList() {
      return this.users.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage);
    },
    rows2() {
      return this.sanses.length;
    },
    itemsForList2() {
      return this.sanses.slice((this.currentPage2 - 1) * this.perPage2, this.currentPage2 * this.perPage2);
    },
    rows3() {
      return this.notices.length;
    },
    itemsForList3() {
      return this.notices.slice((this.currentPage3 - 1) * this.perPage3, this.currentPage3 * this.perPage3);
    },
    rows4() {
      return this.sansRecordsList.length;
    },
    itemsForList4() {
      return this.sansRecordsList.slice(
        (this.currentPage4 - 1) * this.perPage4,
        this.currentPage4 * this.perPage4
      );
    },
  },
  methods: {
    ...mapActions("gap", [
      "getAllSessionGroupsFunction",
      "getAllTecFunction",
      "getAllTypeFunction",
      "getAllSansSubjectFunction",
      "getAllRoleFunction",
      "addUserSingleSessionFunction",
      "addUserWithExcelSessionFunction",
      "getSessionUsersFunction",
      "editUserInSessionFunction",
      "deleteUserOfSessionFunction",
      "getSessionNotificationsFunction",
      "deleteSessionNotificationFunction",
      "getAllSansFunction",
      "addSansInSessionFunction",
      "editSansInSessionFunction",
      "deleteSessionSansFunction",
      "addNoticeForSansFunction",
      "editSessionFunction",
      "getSessionInfoFunction",
      "setIsGroupMeetsFunction",
      "checkUrlFunction",
      "addUserGroupSessionFunction",
      "getAllUsersGroupFunction",
      "getAllActiveSansFunction",
      "sessionPhotoDeleteFunction",
      "getAllUserOrgFunction",
      "getAllRecorStatusFunction",
      "getSansRecordsFunction",
      "setRecordingPolicyFunction",
      "setDirectEntryFunction",
      "getSpecialSupportFunction",
      "deletespecialSupportFunction",
      "getAllStateFunction",
      "addSpecialSupportFunction",
      "setClickTabNavFunction",
      "deleteRecordSessionFunction",
    ]),
    enterTitle(n) {
      let toast = document.querySelector("#b-toaster-top-right .b-toast");
      if (n.target.value.length == 30) {
        if (!toast) {
          this.$bvToast.toast("عنوان جلسه نباید بیشتر از 30 کارکتر باشد.", {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    editSansDayFunc(d, j, i) {
      this.isSansEdit = true;
      this.selectedDay = i;
      this.selectedDaySansId = j;
      this.multistartTime = d.start;
      this.multiendTime = d.end;
      this.$refs["addDaySans-modal"].show();
    },
    deleteSansDayFunc(d, j, i) {
      this.ishover = null;
      this.selectDaysList[i].splice(j, 1);
    },
    finallAddNewSansFunc(i) {
      this.isSansEdit = false;
      this.selectedDay = i;
      this.multistartTime = "00:00";
      this.multiendTime = "00:00";
      this.$refs["addDaySans-modal"].show();
    },
    saveSansFunc() {
      this.ishover = null;
      if (this.isSansEdit) {
        this.selectDaysList[this.selectedDay][this.selectedDaySansId].start = this.multistartTime;
        this.selectDaysList[this.selectedDay][this.selectedDaySansId].end = this.multiendTime;
        this.isSansEdit = false;
      } else {
        this.selectDaysList[this.selectedDay].push({
          start: this.multistartTime,
          end: this.multiendTime,
        });
      }
      this.$refs["addDaySans-modal"].hide();
    },
    deleteRecordFunc(v) {
      this.isRecordDelete = true;
      this.recordDeleted = v;
    },
    setClickTabNavFunc(i) {
      this.setClickTabNavFunction(i);
    },
    setSpecialSupportFunc() {
      console.log(this.isEditSupport);

      if (this.special_support_radio == "in_person") {
        if (this.selectCity == "" || this.selectState == "" || this.phone == "" || this.address == "" || this.selectSansSupport == "") {
          this.$bvToast.toast("وارد کردن تمام موارد پشتیبانی ویژه اجباری است.", {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        } else {
          this.$refs["addSupport-modal"].hide();
          this.addSpecialSupportFunction({
            user_id: this.user.user_id,
            session_id: this.sessionInfo.id,
            support_type: this.special_support_radio,
            state: this.selectState,
            city: this.selectCity,
            address: this.address,
            phone: this.phone,
            sans_id: this.sans_id,
            isEdit: this.isEditSupport,
            note: this.technical_equipment.toString(),
          });
        }
      } else {
        if (this.selectSansSupport == "") {
          this.$bvToast.toast("وارد کردن سانس اجباری می باشد.", {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        } else {
          this.$refs["addSupport-modal"].hide();
          this.addSpecialSupportFunction({
            user_id: this.user.user_id,
            session_id: this.sessionInfo.id,
            support_type: this.special_support_radio,
            state: "",
            city: "",
            address: "",
            phone: "",
            sans_id: this.sans_id,
            isEdit: this.isEditSupport,
            note: "",
          });
        }
      }
    },
    setSelected(v) {
      const result = this.cityList.filter((a) => {
        return parseInt(a.id) == parseInt(v);
      });
      if (result[0]) {
        this.organizationTitle = result[0].title;
      } else {
        this.organizationTitle = "";
      }
    },
    setSelectedState(v) {
      const result = this.stateList.filter((a) => {
        return parseInt(a.id) == parseInt(v);
      });
      if (result[0]) {
        this.stateTitle = result[0].title;
      } else {
        this.stateTitle = "";
      }
    },
    setSelectedSansSupport(v) {
      this.sans_id = v;
    },
    goToSessionFunc(url) {
      this.setDirectEntryFunction(true);
      setTimeout(() => {
        window.location.href = url;
      }, 100);
    },
    selectDayFunc(v) {
      if (this.isactive.includes(v.value)) {
        let id = this.isactive.indexOf(v.value);
        this.isactive.splice(id, 1);
      } else {
        this.isactive.push(v.value);
      }
    },
    setSelectedSans(id) {
      setTimeout(() => {
        if (id == 1) {
          if (this.user.permissions.edit_session_edit_sans) {
            this.editSansFunc(this.selectRow);
          } else {
            this.$bvToast.toast("امکان ویرایش وجود ندارد.", {
              title: "خطا",
              variant: "danger",
              solid: true,
            });
          }
        } else if (id == 2) {
          if (this.user.permissions.edit_session_delete_sans) {
            this.deleteSansFunc(this.selectRow);
          } else {
            this.$bvToast.toast("امکان حذف وجود ندارد.", {
              title: "خطا",
              variant: "danger",
              solid: true,
            });
          }
        }
      }, 150);
    },
    closeAction(id) {
      this.selectRow = id;
    },
    searchUserIconFunc() {
      this.isSearchUserActive = !this.isSearchUserActive;
      setTimeout(() => {
        if (this.isSearchUserActive) {
          document.querySelector(".searchUserInputActive").focus();
        }
      }, 200);
    },
    searchSansIconFunc() {
      this.isSearchSansActive = !this.isSearchSansActive;
      setTimeout(() => {
        if (this.isSearchSansActive) {
          document.querySelector(".searchUserInputActive").focus();
        }
      }, 200);
    },
    forceRerender() {
      this.componentKey += 1;
    },
    sliceTime(t) {
      let Hfilter = [];
      let Mfilter = [];
      let time = t.split(":");
      let Hindex = parseInt(time[0]);
      let Mindex = parseInt(time[1]);
      for (Mindex; Mindex < 60; Mindex++) {
        Mfilter.push(Mindex);
      }
      for (Hindex; Hindex < 24; Hindex++) {
        Hfilter.push(Hindex);
      }
      this.hourRange = Hfilter;
      this.minuteRange = Mfilter;
    },
    selectStartDate(e) {
      this.startDate = e.year + "/" + e.month + "/" + e.day;
      this.endDate = e.year + "/" + e.month + "/" + e.day;
      this.startDateLimit = e.year + "/" + e.month + "/" + e.day;
      setTimeout(() => {
        this.forceRerender();
      }, 200);
    },
    selectSubjectFunc(v) {
      this.notice.subject = v.target.selectedOptions[0]._value;
      this.notice.description = this.notice.subject.note;
    },
    noticesFunc() {
      this.notice.type = "";
      this.notice.description = "";
      this.notice.subject = "";
      this.notice.time = "00:00";
      this.notice.date = "";
      this.sansSelectedId = "";
      this.sans = "";
      this.isSansInNotify = true;
      this.getAllActiveSansFunction({
        user_id: this.user.user_id,
        session_id: this.sessionInfo.id,
      });
    },
    addNoticeForSansFunc() {
      this.addNoticeForSansFunction({
        user_id: this.user.user_id,
        sans_id: this.sans,
        subject_id: this.notice.subject.id,
        send_type: this.notice.type.value,
        content: this.notice.description,
        send_date: this.notice.date,
        send_time: this.notice.time,
      });
      this.$refs["notices-modal"].hide();
    },
    selectRecorcStatusFunc(i) {
      this.isrecordStatus = i;
    },
    deleteBanerFunc() {
      this.isPhotoDelete = true;
    },
    deleteLogoFunc() {
      this.isLogoDelete = true;
    },
    croppie(e) {
      var files = e.target.files || e.dataTransfer.files;
      this.logoFile = e.target.files[0];
      if (!files.length) return;

      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.croppieRef.bind({
          url: e.target.result,
        });
      };

      reader.readAsDataURL(files[0]);
      setTimeout(() => {
        this.crop();
      }, 500);
    },
    crop() {
      let options = {
        type: "base64",
        size: { width: 100, height: 100 },
        format: "png",
      };
      this.$refs.croppieRef.result(options, (output) => {
        this.cropped = output;
      });
    },
    croppie1(e) {
      var files = e.target.files || e.dataTransfer.files;
      this.photoFile = e.target.files[0];
      if (!files.length) return;

      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.croppieRef.bind({
          url: e.target.result,
        });
      };

      reader.readAsDataURL(files[0]);
      setTimeout(() => {
        this.crop1();
      }, 500);
    },
    crop1() {
      let options = {
        type: "base64",
        size: { width: 100, height: 100 },
        format: "png",
      };
      this.$refs.croppieRef.result(options, (output) => {
        this.cropped1 = output;
      });
    },
    selectLogoFunc() {
      document.getElementById("logoFileInput").click();
    },
    selectBanerFunc() {
      document.getElementById("banerFileInput").click();
    },
    changePhotoFunc(e) {
      if (e) {
        if (this.photoFile && this.photoFile.name) {
          this.$bvToast.toast("تنها مجاز به ارسال یک فایل می باشید.", {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        } else {
          this.photoFile = e;
        }
      }
    },
    addNewSansFunc() {
      this.isTabAvtive = 1;
      this.selectDaysList = [[], [], [], [], [], [], []];
      this.selectedDay = 0;
      this.selectedDaySansId = 0;
      this.ishover = null;
      this.multistartTime = "00:00";
      this.multiendTime = "00:00";
      this.isSansEdit = false;
      this.isEditSans = false;
      this.startDate = "";
      this.endDate = "";
      this.startTime = "00:00";
      this.endTime = "00:00";
      this.gender = "all";
      (this.days = []), this.$refs["addSans-modal"].show();
    },
    addSansFinalBtn() {
      if (this.isEditSans) {
        this.editSansInSessionFunction({
          user_id: this.user.user_id,
          session_sans_id: this.editSansId,
          date_from: this.startDate,
          time_from: this.startTime,
          date_to: this.startDate,
          time_to: this.endTime,
          // gender: this.gender,
          title: this.sansTitle,
        });
      } else {
        this.addSansInSessionFunction({
          user_id: this.user.user_id,
          session_id: this.sessionInfo.id,
          date_from: this.startDate,
          time_from: this.startTime,
          date_to: this.endDate,
          time_to: this.endTime,
          days: this.isactive.length ? this.isactive.toString() : "",
          // gender: this.gender,
          title: this.sansTitle,
        });
      }
    },
    editTechnologyFunc() {
      this.url = this.sessionInfo.landing_url == "undefined" ? "" : this.sessionInfo.landing_url;
      this.technologyText = this.sessionInfo.note == "undefined" ? "" : this.sessionInfo.note;
      this.isrecordStatus = this.sessionInfo.record ? 1 : 0;
      this.technologyType = this.sessionInfo.technology;
      this.logoFile.name = this.sessionInfo.logo ? this.sessionInfo.logo : "";
      this.photoFile.name = this.sessionInfo.banner ? this.sessionInfo.banner : "";
      this.$refs["editTechnology-modal"].show();
    },
    editTechnologyFinalFunc() {
      this.checkUrlFunction({
        user_id: this.user.user_id,
        session_id: this.sessionInfo.id,
        url: this.url,
      });
      this.$refs["editTechnology-modal"].hide();
    },
    showRecordFunc(v) {
      this.sansRecord = v;
      this.sansRecordsList = [];
      this.mobileSansRecordsList = [];
      this.getSansRecordsFunction({
        user_id: this.user.user_id,
        session_sans_id: v.id,
      });
      this.$refs["records-modal"].show();
    },
    editSansFunc(v) {
      if (v.edit_status) {
        this.isEditSans = true;
        this.editSansId = v.id;
        this.sansTitle = v.title;
        this.startDate = v.date_from;
        this.endDate = v.date_to;
        this.startTime = v.time_from;
        this.endTime = v.time_to;
        // this.gender = v.gender;
        this.$refs["editSans-modal"].show();
      } else {
        this.$bvToast.toast("امکان ویرایش سانس برگزار شده وجود ندارد.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      }
    },
    deleteSansFunc(v) {
      this.isSunsDelete = true;
      this.sunsDeleted = v;
    },
    deleteNoticeFunc(v) {
      this.isNoticeDelete = true;
      this.noticeDeleted = v;
    },
    returnFunc() {
      if (this.setIsGroupMeets) {
        this.$router.push({ name: "meetGroupEdit" });
        this.setIsGroupMeetsFunction(false);
      } else {
        this.$router.push({ name: "myMeets" });
      }
    },
    addFileFunc(e) {
      if (e) {
        if (this.addUser.file && this.addUser.file.name) {
          this.$bvToast.toast("تنها مجاز به ارسال یک فایل می باشید.", {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        } else {
          this.addUser.file = e;
        }
      }
    },
    deleteFileFunc() {
      this.$refs["excel-input"].reset();
      this.addUser.file = {};
    },
    editUserFunc(v) {
      this.isEdit = true;
      this.userEdited = v;
      this.editUser.name = v.first_name;
      this.editUser.family = v.last_name;
      // this.editUser.email = v.email;
      this.editUser.mobile = v.mobile;
      this.editUser.role = v.role;
      this.$refs["edit-modal"].show();
    },
    editSupportFunc(v) {
      this.isEditSupport = true;
      this.supportEdited = v;
      this.special_support_radio = v.support_type;
      this.selectCity = v.city;
      this.selectState = v.state;
      this.phone = v.phone;
      this.technical_equipment = v.note;
      this.address = v.address;
      this.selectSansSupport = v.sans_title
      this.isSansInNotify = false;
      this.getAllActiveSansFunction({
        user_id: this.user.user_id,
        session_id: this.sessionInfo.id,
      });
    },
    editUserFinalBtn() {
      this.editUserInSessionFunction({
        first_name: this.editUser.name,
        last_name: this.editUser.family,
        // email: this.editUser.email,
        mobile: this.editUser.mobile,
        role: this.editUser.role,
        user_id: this.user.user_id,
        session_user_id: this.userEdited.session_user_id,
      });
    },
    deleteUserFunc(v) {
      this.isDelete = true;
      this.userDeleted = v;
    },
    deleteSupportFunc(v) {
      this.isDeleteSupport = true;
      this.supportDeleted = v;
    },
    addNewUserFunc() {
      this.$refs["add-modal"].show();
    },
    addNewSupportFunc() {
      this.special_support_radio = "";
      this.selectCity = "";
      this.selectState = "";
      this.selectSansSupport = "";
      this.isSansInNotify = false;
      this.isEditSupport = false;
      this.getAllActiveSansFunction({
        user_id: this.user.user_id,
        session_id: this.sessionInfo.id,
      });
    },
    recordMeetBtn() {
      if (this.title == "") {
        this.$bvToast.toast("عنوان را وارد نمایید.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else if (this.user.is_organ == "yes") {
        if (this.userOrg == "" || !this.userOrg) {
          this.$bvToast.toast("سازمان را وارد نمایید.", {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      } else if (this.capacity == "") {
        this.$bvToast.toast("ظرفیت را وارد نمایید.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else {
        this.editSessionFunction({
          user_id: this.user.user_id,
          session_id: this.sessionInfo.id,
          title: this.title,
          group_id: this.sessionGroup,
          total_capacity: this.capacity,
          guest_policy: this.guestStatus.value,
          record: this.isrecordStatus == 1 ? true : false,
          landing_url: this.url,
          logo: this.logoFile,
          banner: this.photoFile,
          note: this.technologyText,
          organ_id: this.userOrg,
          status: this.statusVal,
        });
      }
    },
    mobileNumber(Number) {
      var IndNum = /^[0]?[789]\d{9}$/;

      if (IndNum.test(Number) && Number.length == 11) {
        return true;
      } else {
        return false;
      }
    },
    validateEmail(email) {
      return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    },
    addUserSingleFinalBtn() {
      if (
        this.addUser.name == "" ||
        this.addUser.mobile == "" ||
        this.addUser.role == "" ||
        this.addUser.family == ""
      ) {
        this.$bvToast.toast("پر کردن تمام موارد الزامی می باشد.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else if (!this.mobileNumber(this.addUser.mobile)) {
        this.$bvToast.toast("تلفن همراه را بصورت صحیح وارد نمایید.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else {
        this.addUserSingleSessionFunction({
          first_name: this.addUser.name,
          last_name: this.addUser.family,
          // email: this.addUser.email,
          mobile: this.addUser.mobile,
          role: this.addUser.role,
          user_id: this.user.user_id,
          session_id: this.sessionInfo.id,
        });
      }
    },
    saveUserWithGroupFunc() {
      this.addUserGroupSessionFunction({
        user_group_id: this.groupTitle.id,
        user_id: this.user.user_id,
        session_id: this.sessionInfo.id,
      });
    },
    addUserExcellFinalBtn() {
      this.addUserWithExcelSessionFunction({
        excel: this.addUser.file,
        user_id: this.user.user_id,
        session_id: this.sessionInfo.id,
      });

      this.$refs["add-modal"].hide();
    },
    recordStatusFunc(i) {
      this.recordStatusIndex = i;
    },
  },
  watch: {
    detailsTabIndex(n) {
      this.isActiveTab = n;
    },
    addSpecialSupportStatus(n) {
      if (n.code == 100) {
        this.$bvToast.toast(n.message, {
          title: "تایید",
          variant: "success",
          solid: true,
        });
        this.getSpecialSupportFunction({
          user_id: this.user.user_id,
          session_id: this.sessionInfo.id,
        });
      } else {
        this.$bvToast.toast(n.message, {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      }
    },
    selectState(n) {
      if (n == null) {
        this.cityList = [];
        this.selectCity = "";
      } else {
        this.getAllStateFunction({
          user_id: this.user.user_id,
          type_id: "3",
          parent_id: n,
        });
      }
    },
    allCities(n) {
      this.cityList = n.information;
    },
    searchSans(n) {
      this.sanses = n.session_sanses;
      let searchArray = this.allSans.session_sanses.filter((ticket) => {
        return (
          ticket.title.toLowerCase().includes(n) ||
          ticket.status.toLowerCase().includes(n) ||
          ticket.time_from.toLowerCase().includes(n) ||
          ticket.time_to.toLowerCase().includes(n) ||
          ticket.date_from.toLowerCase().includes(n) ||
          ticket.date_to.toLowerCase().includes(n)
        );
      });
      this.sanses = searchArray;
    },
    searchUser(n) {
      let searchArray = this.sessionUsers.session_users.filter((ticket) => {
        return (
          ticket.first_name.toLowerCase().includes(n) ||
          ticket.last_name.toLowerCase().includes(n) ||
          ticket.mobile.toLowerCase().includes(n) ||
          ticket.role_title.toLowerCase().includes(n)
        );
      });
      this.users = searchArray;
      this.mobileUsers = searchArray;
    },
    recordStatus(n) {
      setTimeout(() => {
        for (let i = 0; i < n.length; i++) {
          const result = n[i].split("/");
          let index = result[2];
          let pId = result[1];
          let rId = result[0];
          if (parseInt(index) == this.recordStatusIndex) {
            this.setRecordingPolicyFunction({
              user_id: this.user.user_id,
              recording_id: pId,
              policy: rId,
            });
          }
        }
      }, 300);
    },
    sessionPhotoDeleteStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.getSessionInfoFunction({
            user_id: this.user.user_id,
            session_id: this.sessionInfo.id,
          });
          this.returnFunc();
        } else {
          this.$bvToast.toast("حذف با مشکل مواجه گردید.", {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    sans(n) {
      this.getAllSansSubjectFunction({
        user_id: this.user.user_id,
        sans_id: n,
      });
    },
    startTime(n) {
      this.sliceTime(n);
    },
    startDate(n) {
      this.endDate = n;
    },
    checkUrlStatus(n) {
      if (n.is_valid) {
        this.recordMeetBtn();
      } else {
        this.$bvToast.toast(n.message, {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      }
    },
    getSansRecordsStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.sansRecordsList = n.contents.recording;
          this.mobileSansRecordsList = n.contents.recording;
          setTimeout(() => {
            for (let i = 0; i < n.contents.recording.length; i++) {
              this.recordStatus.push(
                n.contents.recording[i].policy + "/" + n.contents.recording[i].id + "/" + i
              );
            }
          }, 200);
        } else {
          this.sansRecordsList = [];
          this.mobileSansRecordsList = [];
        }
      }
    },
    setRecordingPolicyStatus() {},
    editSessionStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100 || n.code == 105) {
          this.getSessionInfoFunction({
            user_id: this.user.user_id,
            session_id: this.sessionInfo.id,
          });
          this.returnFunc();
          setTimeout(() => {
            this.$bvToast.toast(n.message, {
              title: "تایید",
              variant: "success",
              solid: true,
            });
          }, 1000);
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    addUserGroupSessionStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.getSessionUsersFunction({
            user_id: this.user.user_id,
            session_id: this.sessionInfo.id,
          });
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
          this.addUser.name = "";
          this.addUser.family = "";
          // this.addUser.email = "";
          this.addUser.mobile = "";
          this.addUser.role = "";
          this.addUser.file = {};
          this.activeId = 0;
          this.$refs["add-modal"].hide();
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    addNoticeForSansStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.getSessionNotificationsFunction({
            user_id: this.user.user_id,
            session_id: this.sessionInfo.id,
          });
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    deleteSessionSansStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.getAllSansFunction({
            user_id: this.user.user_id,
            session_id: this.sessionInfo.id,
          });
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    deletespecialSupportStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.getSpecialSupportFunction({
            user_id: this.user.user_id,
            session_id: this.sessionInfo.id,
          });
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    deleteRecordSessionStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.sansRecordsList = [];
          this.mobileSansRecordsList = [];
          this.getSansRecordsFunction({
            user_id: this.user.user_id,
            session_sans_id: this.sansRecord.id,
          });
          this.$refs["records-modal"].hide();
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    editSansInSessionStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.getAllSansFunction({
            user_id: this.user.user_id,
            session_id: this.sessionInfo.id,
          });
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
          this.$refs["editSans-modal"].hide();
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    addSansInSessionStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.getAllSansFunction({
            user_id: this.user.user_id,
            session_id: this.sessionInfo.id,
          });
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
          this.$refs["addSans-modal"].hide();
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    allSans(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.sanses = n.session_sanses;
        } else {
          this.sanses = [];
        }
      }
    },
    sessionNotifications(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.notices = n.notifications;
        } else {
          this.notices = [];
        }
      }
    },
    editUserInSessionStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.getSessionUsersFunction({
            user_id: this.user.user_id,
            session_id: this.sessionInfo.id,
          });
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
          this.$refs["edit-modal"].hide();
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    deleteUserOfSessionStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.getSessionUsersFunction({
            user_id: this.user.user_id,
            session_id: this.sessionInfo.id,
          });
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    deleteSessionNotificationStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.getSessionNotificationsFunction({
            user_id: this.user.user_id,
            session_id: this.sessionInfo.id,
          });
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    addUserWithExcelSessionStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.getSessionUsersFunction({
            user_id: this.user.user_id,
            session_id: this.sessionInfo.id,
          });
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
          this.addUser.name = "";
          this.addUser.family = "";
          // this.addUser.email = "";
          this.addUser.mobile = "";
          this.addUser.role = "";
          this.addUser.file = {};
          this.activeId = 0;
          this.$refs["add-modal"].hide();
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    sessionUsers(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.users = n.session_users;
        } else {
          this.users = [];
        }
      }
    },
    allActiveSans(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          if (this.isSansInNotify) {
            this.$refs["notices-modal"].show();
          } else {
            this.$refs["addSupport-modal"].show();
          }
          this.allActiveSansVal = n.session_sanses;
        } else {
          this.users = [];
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    addUserSingleSessionStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.getSessionUsersFunction({
            user_id: this.user.user_id,
            session_id: this.sessionInfo.id,
          });
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
          this.addUser.name = "";
          this.addUser.family = "";
          // this.addUser.email = "";
          this.addUser.mobile = "";
          this.addUser.role = "";
          this.addUser.file = {};
          this.activeId = 0;
          this.$refs["add-modal"].hide();
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    startDate() {},
  },
  mounted() {
    this.isActiveTab = this.detailsTabIndex;
    if (Object.keys(this.sessionUsers).length) {
      if (this.sessionUsers.code == 100) {
        this.users = this.sessionUsers.session_users;
      }
    }
    if (Object.keys(this.sessionNotifications).length) {
      if (this.sessionNotifications.code == 100) {
        this.notices = this.sessionNotifications.notifications;
      }
    }
    if (Object.keys(this.allSans).length) {
      if (this.allSans.code == 100) {
        this.sanses = this.allSans.session_sanses;
      }
    }

    if (Object.keys(this.sessionInfo).length) {
      let guest = {};
      if (this.sessionInfo.guest_policy) {
        guest = this.guestList.filter((x) => {
          return x.value == this.sessionInfo.guest_policy;
        });
      }
      this.title = this.sessionInfo.title;
      this.statusVal = this.sessionInfo.session_status;
      this.capacity = this.sessionInfo.total_capacity;
      this.userOrg = this.sessionInfo.organ_id;
      this.sessionGroup = this.sessionInfo.session_group_id;
      this.guestStatus = guest.length ? guest[0] : "";
      this.url = this.sessionInfo.landing_url == "undefined" ? "" : this.sessionInfo.landing_url;
      this.technologyText = this.sessionInfo.note == "undefined" ? "" : this.sessionInfo.note;
      this.isrecordStatus = this.sessionInfo.record ? 1 : 0;
      this.technologyType = this.sessionInfo.technology;
      this.logoFile.name = this.sessionInfo.logo ? this.sessionInfo.logo : "";
      this.photoFile.name = this.sessionInfo.banner ? this.sessionInfo.banner : "";
    }
  },
};
</script>
